import React from "react";
import "../../../../../css/pages/ca_pages/teams/employees_model/EmployeeToolbar.css";

const ActivityToolbar = ({
    filters,
    employees = [],
    departments = [],
    onSearchChange,
    onEmployeeChange,
    onDepartmentChange,
    onStatusChange,
    onActionChange,
    onReset,
    activityCount,
    totalCount,
    loading,
    refreshing,
    onRefresh,
}) => {
    return (
        <div className="employee-toolbar">
            <div className="employee-toolbar-top">
                <div className="employee-search">
                    <span>🔍</span>

                    <input
                        type="text"
                        placeholder="Search activity..."
                        value={filters.search}
                        onChange={(event) => onSearchChange(event.target.value)}
                        disabled={loading}
                    />
                </div>

                <button
                    type="button"
                    className="reset-btn"
                    onClick={onRefresh}
                    disabled={loading || refreshing}
                >
                    {refreshing ? "Refreshing..." : "Refresh"}
                </button>
            </div>

            <div className="employee-toolbar-bottom">
                <div className="employee-filters">
                    <select
                        value={filters.employee}
                        onChange={(event) => onEmployeeChange(event.target.value)}
                    >
                        <option value="">Employee</option>

                        {employees.map((employee) => (
                            <option
                                key={employee.id}
                                value={employee.id}
                            >
                                {employee.name}
                            </option>
                        ))}
                    </select>

                    <select
                        value={filters.department}
                        onChange={(event) => onDepartmentChange(event.target.value)}
                    >
                        <option value="">Department</option>

                        {departments.map((department) => (
                            <option
                                key={department}
                                value={department}
                            >
                                {department}
                            </option>
                        ))}
                    </select>

                    <select
                        value={filters.status}
                        onChange={(event) => onStatusChange(event.target.value)}
                    >
                        <option value="">Task Status</option>
                        <option value="pending">Pending</option>
                        <option value="in_progress">In Progress</option>
                        <option value="paused">Paused</option>
                        <option value="review">Review</option>
                        <option value="completed">Completed</option>
                        <option value="cancelled">Cancelled</option>
                    </select>

                    <select
                        value={filters.action}
                        onChange={(event) => onActionChange(event.target.value)}
                    >
                        <option value="">Activity Type</option>
                        <option value="created">Created</option>
                        <option value="updated">Updated</option>
                        <option value="assigned">Assigned</option>
                        <option value="unassigned">Unassigned</option>
                        <option value="started">Started</option>
                        <option value="paused">Paused</option>
                        <option value="resumed">Resumed</option>
                        <option value="completed">Completed</option>
                        <option value="cancelled">Cancelled</option>
                        <option value="commented">Commented</option>
                        <option value="reassigned">Reassigned</option>
                    </select>

                    <button
                        type="button"
                        className="reset-btn"
                        onClick={onReset}
                    >
                        Reset
                    </button>
                </div>

                <div className="employee-count">
                    Showing{" "}
                    <strong>{activityCount}</strong>{" "}
                    of{" "}
                    <strong>{totalCount}</strong>{" "}
                    Activities
                </div>
            </div>
        </div>
    );
};

export default ActivityToolbar;
